<template>
    <img :src="icon" :alt="alt" :class="classNames" />
</template>

<script setup lang="ts">
interface ISvgIcon {
    icon: string;
    alt: string;
    classNames?: string;
}

withDefaults(defineProps<ISvgIcon>(), {
    classNames: 'vertical-align-middle align-self-center'
});
</script>
